import type { QueryClient, QueryFilters } from '@tanstack/react-query';

/** Cancel even the initial fetch: v4 cancelRefetch only cancels queries with data. */
export const invalidateStorageQueries = async (
  queryClient: QueryClient,
  filters: QueryFilters,
) => {
  // Keep this event scoped to existing queries, even if the cache is cleared
  // and repopulated (for example, during logout) while cancellation settles.
  const queries = new Set(queryClient.getQueryCache().findAll(filters));
  const target: QueryFilters = { predicate: (query) => queries.has(query) };
  await queryClient.cancelQueries(target);
  await queryClient.invalidateQueries({ ...target, refetchType: 'all' });
};